import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, venueId) =>
  httpClient.get(URLS.stats.yourInsightsModulesList(venueId)).then(transformV2ClientResponse);

export default makeEntityScaffold('SAGA.API.STATS_YOUR_INSIGHTS_MODULES_LIST', handler, { defaultKey: 1 });
